<template>
  <div class="page">
    <home-header activeIndex="2" pageTitle="录取分数线查询" />
    <div class="pageWrap">
      <div class="list">
        <div style="padding: 40px 80px">
          <a-input placeholder="请输入专业名称" v-model="zyName" />
          <a-button style="margin: 0 16px" type="primary" @click="search">
            搜索
          </a-button>
          <a-button type="primary" @click="rest"> 重置 </a-button>
        </div>

        <a-table
          :columns="columns"
          :data-source="data"
          bordered
          :pagination="false"
        >
          <a slot="name" slot-scope="text">{{ text }}</a>
        </a-table>
      </div>

      <div class="pagination">
        <a-pagination
          v-model="page"
          show-quick-jumper
          :showSizeChanger="true"
          :pageSizeOptions="['10', '20', '50', '100']"
          @change="onChangePage"
          :total="total"
          :showTotal="showTotal"
          :page-size="size"
          show-less-items
          @showSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import moment from "moment";
import { getLqList } from "@/api/look";
import HomeHeader from "@/components/HomeHeader";
import Footer from "@/components/footer";
import { getStuDetail } from "@/api/form.js";
export default {
  name: "notice",
  components: {
    HomeHeader,
    Footer,
  },
  data() {
    return {
      page: 1,
      size: 10,
      zyName: "",
      total: 200,
      rPlanId: "",

      columns: [
        {
          title: "专业",
          dataIndex: "zyName",
          key: "zyName",
          align: "center",
          //   scopedSlots: { customRender: "name" },
        },
        {
          title: "录取分数",
          dataIndex: "score",
          key: "score",
          align: "center",
        },
      ],
      data: [],
    };
  },

  methods: {
    showTotal: function (total, range) {
      return (
        "当前第 " +
        range[0] +
        " - " +
        range[1] +
        " 条，共：" +
        total +
        " 条数据"
      );
    },
    search() {
      this.getList();
    },
    rest() {
      this.zyName = "";
      this.getList();
    },
    onChangePage(e) {
      this.page = e;
      this.getList();
    },
    handleSizeChange(current, pageSize) {
      this.size = pageSize;
      this.getList();
    },
    getList() {
      getLqList({
        page: this.page,
        size: this.size,
        rPlanId: this.rPlanId,
        zyName: this.zyName,
      }).then((res) => {
        console.log(res, "1209");
        this.total = res.total;
        this.data = res.rows;
      });
    },
  },
  mounted() {
    getStuDetail().then((res) => {
      this.rPlanId = res.vPlanId;
      this.getList();
    });
  },
};
</script>

<style lang="less" scoped>
.pageWrap {
  width: 1200px;
  background-color: #ffffff;
  border-radius: 4px;
  margin: 20px auto;
}
.list {
  min-height: 380px;
}
.pagination {
  text-align: center;
  padding: 24px 0 32px;
  /deep/ .ant-pagination-item-active {
    background: #2a79ff;
    a {
      color: #fff;
    }
  }
}
/deep/.ant-pagination-options-size-changer {
  width: 100px !important;
}
/deep/ .ant-input {
  width: 240px;
}
/deep/ .ant-table-body {
  padding: 0 80px;
}
</style>
